import { Component } from '@angular/core';

@Component({
  selector: 'icon-eye-close',
  templateUrl: './icon-eye-close.component.html',
  styles: []
})
export class IconEyeCloseComponent {}
